import { useState } from "react";
import { call, formatError } from "@/lib/api";
import { Modal } from "@/components/common";

export function ChangePasswordModal({ onClose, toast }) {
  const [f, setF] = useState({ current_password:"", new_password:"", confirm:"" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (f.new_password !== f.confirm) { toast("Konfirmasi password tidak sama", "error"); return; }
    setBusy(true);
    try { await call.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }); toast("Password berhasil diganti"); onClose(); }
    catch (e) { toast(formatError(e), "error"); }
    finally { setBusy(false); }
  };
  return (
    <Modal title="Ganti Password" subtitle="Gunakan minimal 8 karakter" onClose={onClose} onSubmit={submit} busy={busy} testid="change-password-modal" submitLabel="Simpan Password">
      <div className="form-grid single">
        <label>Password Saat Ini<input required type="password" data-testid="current-password-input" value={f.current_password} onChange={e => setF({ ...f, current_password: e.target.value })} /></label>
        <label>Password Baru<input required type="password" minLength={8} data-testid="new-password-input" value={f.new_password} onChange={e => setF({ ...f, new_password: e.target.value })} /></label>
        <label>Konfirmasi Password Baru<input required type="password" minLength={8} data-testid="confirm-password-input" value={f.confirm} onChange={e => setF({ ...f, confirm: e.target.value })} /></label>
      </div>
    </Modal>
  );
}
